import callAPiBase from './base';

const faresApi = {
  list: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/fareList',
      method: 'GET',
      useToken: true,
      title: 'Fares - Get List',
      params,
    }),
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/fareList',
      method: 'GET',
      useToken: true,
      title: 'Fare - Get List',
      params,
    }),
  listCarFare: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/carFareList',
      method: 'GET',
      useToken: true,
      title: 'Fares - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/fareCreate',
      method: 'POST',
      useToken: true,
      title: 'Fare - Create',
      data,
    }),
  createCarFare: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/carFareCreate',
      method: 'POST',
      useToken: true,
      title: 'Fare - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/fareUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Fare - Update',
      data,
    }),
  updateCarFare: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/carFareUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Fare - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/fareDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Fare - Delete',
      params,
    }),
  deleteCarFare: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/carFareDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Fare - Delete',
      params,
    }),
};

export default faresApi;
export { faresApi };
